var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cjt-container"},[_c('div',{staticClass:"cjt-head"},[_c('top-nav-head')],1),_c('div',{staticClass:"cjt-main"},[_c('router-view')],1),_c('footer-guide'),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }